import {
    validateEmail,
    validatePostalCode,
    validateUSPostalCode,
    validateFirstName,
    validateLastName,
    validateMiddleName,
    validatePrefix,
    validateAddress as validateAddressUtil
} from '../Shared/validations';

const validateMonth = values => {
    if (!values) return;
    if (values.month == null || values.month === '') {
        return { month: 'Invalid Month' };
    }
    return {};
};

const validateDay = values => {
    if (!values) return;
    if (values.day == null || values.day === '') {
        return { day: 'Invalid Day' };
    }
    return {};
};

const validateYear = values => {
    if (!values) return;
    if (values.year == null || values.year === '') {
        return { year: 'Invalid Year' };
    }
    return {};
};

const validateMailingPostalCode = values => {
    if (values.mailingPostalCode == null || values.mailingPostalCode === '') {
        return { mailingPostalCode: 'Invalid Postal Code' };
    } else if (values.mailingPostalCode.length < 5) {
        return { mailingPostalCode: 'Must be 5 characters' };
    } else if (!values.mailingPostalCode.match(/^\d+$/)) {
        return { mailingPostalCode: 'Only numbers allowed' };
    }
    return {};
};

const validatePrevPostalCode = values => {
    if (values.prevPostalCode == null || values.prevPostalCode === '') {
        return { prevPostalCode: 'Invalid Postal Code' };
    } else if (values.prevPostalCode.length < 5) {
        return { prevPostalCode: 'Must be 5 characters' };
    } else if (!values.prevPostalCode.match(/^\d+$/)) {
        return { prevPostalCode: 'Only numbers allowed' };
    }
    return {};
};

const validatePrevLastName = values => {
    if (!values) return;
    if (values.prevLastName == null || values.prevLastName === '') {
        return { prevLastName: 'Invalid Last Name' };
    }
    return {};
};

const validatePrevFirstName = values => {
    if (!values) return;
    if (values.prevFirstName == null || values.prevFirstName === '') {
        return { prevFirstName: 'Invalid First Name' };
    }
    return {};
};

const validatePrevPrefix = values => {
    if (!values) return;
    if (values.prevPrefix == null || values.prevPrefix === '') {
        return { prevPrefix: 'Invalid Prefix' };
    }
    return {};
};

const validateDateOfBirth = values => {
    if (!values) return;
    if (values.dateOfBirth == null || values.dateOfBirth === '') {
        return { dateOfBirth: 'Invalid Date of Birth' };
    }
    return {};
};

const validateUsCitizen = values => {
    if (!values) return;
    if (!values.usCitizen) {
        return { usCitizen: 'Invalid Date of Birth' };
    }
    return {};
};

const validateAddress = values => {
    if (!values) return;
    const addressValidated = validateAddressUtil({ address: values.homeAddress });
    if (addressValidated.address) {
        return { homeAddress: addressValidated.address };
    }
    return {};
};

const validateMailingCity = values => {
    if (!values) return;
    if (values.mailingCity == null || values.mailingCity === '') {
        return { mailingCity: 'Invalid City' };
    }
    return {};
};

const validateMailingAddress = values => {
    if (!values) return;
    const addressValidated = validateAddressUtil({ address: values.mailingAddress });
    if (addressValidated.address) {
        return { mailingAddress: addressValidated.address };
    }
    return {};
};

const validatePrevAddress = values => {
    if (!values) return;
    const addressValidated = validateAddressUtil({ address: values.prevAddress });
    if (addressValidated.address) {
        return { prevAddress: addressValidated.address };
    }
    return {};
};

const validateCity = values => {
    if (!values) return;
    if (values.homeCity == null || values.homeCity === '') {
        return { homeCity: 'Invalid City' };
    }
    return {};
};

const validatePrevCity = values => {
    if (!values) return;
    if (values.prevHomeCity == null || values.prevHomeCity === '') {
        return { prevHomeCity: 'Invalid City' };
    }
    return {};
};

const validateState = values => {
    if (!values) return;
    if (values.stateId == null || values.stateId === '') {
        return { stateId: 'Invalid State' };
    }
    return {};
};

const validateMailingState = values => {
    if (!values) return;
    if (values.mailingStateId == null || values.mailingStateId === '') {
        return { mailingStateId: 'Invalid State' };
    }
    return {};
};

const validatePrevState = values => {
    if (!values) return;
    if (values.prevStateId == null || values.prevStateId === '') {
        return { prevStateId: 'Invalid State' };
    }
    return {};
};

const validateIdNumber = values => {
    if (!values) return;
    if (!values.idNumber || !values.idNumber.match(/^(NONE|\d{4,})$/gi)) {
        return { idNumber: 'Invalid ID Number' };
    }
    return {};
};

const validateParty = values => {
    if (!values) return;
    if (values.party == null || values.party === '') {
        return { party: 'Invalid Party' };
    }
    return {};
};

const validateRace = values => {
    if (!values) return;
    if (values.race == null || values.race === '') {
        return { race: 'Invalid Race' };
    }
    return {};
};

const validatePhone = values => {
    if (!values) return;
    if (values.phone) {
        if (values.phone.length > 0 && values.phone.length < 12) {
            return { phone: 'Must be 10 characters' };
        }
    }
    return {};
};

export const validatePopup = values => {
    const errors = {
        ...validateUSPostalCode(values),
        ...validateMonth(values),
        ...validateDay(values),
        ...validateYear(values)
    };
    return errors;
};

export const validateStep1 = values => {
    const errors = {
        ...validatePrefix(values),
        ...validateFirstName(values),
        ...validateLastName(values),
        ...validateMiddleName(values),
        ...validateEmail(values),
        ...validateDateOfBirth(values),
        ...validateUsCitizen(values)
    };

    return errors;
};

export const validateStep2 = values => {
    const errors = {
        ...validateAddress(values),
        ...validateCity(values),
        ...validateState(values),
        ...validatePostalCode(values),
        ...validatePhone(values)
    };

    return errors;
};

export const validateStep4 = values => {
    const errors = {
        ...validateIdNumber(values)
    };

    return errors;
};

export const validateStep5 = values => {
    const errors = {
        ...validateMailingAddress(values),
        ...validateMailingCity(values),
        ...validateMailingState(values),
        ...validateMailingPostalCode(values)
    };

    return errors;
};

export const validateStep6 = values => {
    const errors = {
        ...validatePrevLastName(values),
        ...validatePrevPrefix(values),
        ...validatePrevFirstName(values)
    };

    return errors;
};

export const validateStep7 = values => {
    const errors = {
        ...validatePrevAddress(values),
        ...validatePrevCity(values),
        ...validatePrevState(values),
        ...validatePrevPostalCode(values)
    };

    return errors;
};

export const validateStep8 = values => {
    const errors = {
        ...validateParty(values),
        ...validateRace(values)
    };

    return errors;
};
